import React from 'react';
import PropTypes from 'prop-types';
import { toLower } from '../../../../util/lodashlike';

const HiGoMeLoColors = (id = 'none') => {
  const colorObject = {
    high: '#DF6057', //Red
    good: '#E29840', // Orange
    medium: '#E29840', // Orange
    low: '#71C969', // Green
    none: '#858383' // Gray
  };

  return colorObject[toLower(id)] || '#858383';
};

HiGoMeLoColors.propTypes = {
  id: PropTypes.oneOf(['high', 'good', 'medium', 'low'])
};

export default HiGoMeLoColors;
